import { GET_FILTER_VALUES, GET_FILTER_VALUES_SUCCESS, GET_FILTER_VALUES_ERROR, GET_FILTER_VALUES_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetFilterValues = (state = initialState, action) => {
  switch (action.type) {
    case GET_FILTER_VALUES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_FILTER_VALUES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_FILTER_VALUES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_FILTER_VALUES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetFilterValues;
